export const imageUrl = "https://database.sumadepobangunan.com/";
export const urlServer = "https://himitsu.sumadepobangunan.com/";
export const urlServer2 = "https://server.sumadepobangunan.com/";

// export const imageUrl = "https://b0e0-182-253-87-51.ngrok-free.app/";
// export const urlServer = "http://localhost:8000/";
// export const urlServer2 = "http://localhost:8000/";